<template>
    <div>
      <div :class="data.length > 0 ? 'table-container' : ''">
        <table>
          <thead>
            <tr>
              <th
                :class="header.class ? header.class : ''"
                v-for="(header, i) in headers"
                :key="i"
              >
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <template v-if="!loading || data.length > 0">
          <TableBody @editarCita="handleEditar" @status="handleStatus" v-for="(item) in data" :key="item._id" :item="item" />
        </template>
        </table>
      </div>
      <div v-if="data.length < 1" class="empty-container">
        <div v-if="!loading && data.length < 1" class="message-container">
          <img
            class="icon-message"
            :src="require(`../../../assets/imgs/${imgSrc}`)"
            alt="Sin datos"
          />
          <p class="message">{{ message }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TableBody from './TableBody.vue';
  export default {
    components:{
      TableBody
    },
    props: {
      headers: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Array,
        default: ()=>[],
      },
      message: {
        type: String,
        default: "No se encontrarón clientes",
      },
      imgSrc: {
        type: String,
        default: "user-not-found.png",
      },
    },
    emits:["status","editarCita"],
    methods:{
      handleStatus(status){
      this.$emit("status",status)
    },
    handleEditar(item){
      this.$emit("editarCita",item)
    }
    }
    // data() {
    //   return {};
    // },
  };
  </script>
  
  <style scoped>

 
  .table-container {
    min-height: 562.5px;
    background-color: #fff;
  }
  .arrow{
  max-width: 50px;
}
  .empty-container {
    min-height: 500px;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .message-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }
  
  .icon-message {
    width: 100px;
    height: 100px;
  }
  
  .message {
    text-align: center;
    font: normal normal 600 20px/23px Open Sans;
    letter-spacing: 0px;
    color: #0a4f9c;
  }
  
  table {
    background-color: #fff;
    text-align: left;
    border-collapse: collapse;
    width: 100%;
  }
  
  th {
    padding: 20px 20px;
    font: normal normal bold 16px/22px Open Sans;
    color: #616161;
  }
  
  td {
    padding: 15px 20px;
    font: normal normal normal 14px/19px Open Sans;
    color: #616161;
  }
  
  thead {
    background: #f3f3f3 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
  }
  tr:first-child {
    border-top: none;
  }
  tr {
    border: 1px solid #e5e5e5;
  }
  tbody tr {
    cursor: pointer;
  }
  tbody tr:hover {
    background: #f3f3f3 0% 0% no-repeat padding-box;
  }

  .hide-web {
      display: none;
    }
  
  /* TABLET */
  @media screen and (max-width: 1279px) {

    .center-table{
    text-align: center;
  }
    .hide-web {
      display: table-cell;
    }
    .hide-tablet {
  display: none;
}
  }
  
  /* MOVIL */
  @media screen and (max-width: 767px) {
    /* .table-container{
      min-height: 342.5px;
  }
  
  .empty-container{
    min-height: 300px;
  }  */
  /* .hide-tablet {
  display: none;
} */
  .hide-web {
      display: table-cell;
    }

    .hide-movil {
      display: none;
    }
  
    th {
      padding: 20px 5px;
      font: normal normal bold 11px/22px Open Sans;
    }
  
    td {
      padding: 15px 5px;
      font: normal normal normal 10px/19px Open Sans;
    }
  }
  </style>
  